var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value", "disabled"];
import { clearNumber } from '@/utils/formatting';
import { computed, nextTick, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'numeric-input',
    props: {
        modelValue: {
            required: true,
            type: null,
        },
        formatOnBlur: {
            required: false,
            type: Boolean,
            default: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        allowMinus: {
            required: false,
            type: Boolean,
            default: false,
        },
        decimalPlaces: {
            type: Number,
            default: 2,
        },
        format: {
            type: String,
            default: '0',
        },
        blurFormat: {
            type: String,
            default: '0.00',
        },
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const input = ref(null);
        const formatPlaces = computed(() => '0'.repeat(props.decimalPlaces));
        const formatComputed = computed(() => {
            if (formatPlaces.value.length) {
                return `${props.format}.[${formatPlaces.value}]`;
            }
            return props.format;
        });
        const blurFormatComputed = computed(() => {
            if (formatPlaces.value.length) {
                return `${props.blurFormat}[${formatPlaces.value}]`;
            }
            return props.blurFormat;
        });
        function onBlur() {
            if (props.formatOnBlur && input && input.value) {
                input.value.value = clearNumber(props.modelValue, blurFormatComputed.value, false, props.allowMinus);
            }
        }
        // Minus negates the number wherever the caret is, instead of being stripped when it isn't typed first.
        function onKeydown(event) {
            if (!props.allowMinus || event.key !== '-') {
                return;
            }
            event.preventDefault();
            const target = event.target;
            if (!target.value.startsWith('-')) {
                _updateInputValue(`-${target.value}`);
            }
        }
        function onInput(event) {
            return __awaiter(this, void 0, void 0, function* () {
                yield nextTick();
                const target = event.target;
                const newValue = clearNumber(target.value, formatComputed.value, false, props.allowMinus);
                _updateInputValue(newValue);
            });
        }
        function _updateInputValue(value) {
            if (input.value) {
                input.value.value = value;
            }
            emit('update:modelValue', value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", {
                ref_key: "input",
                ref: input,
                value: __props.modelValue,
                onInput: onInput,
                onKeydown: onKeydown,
                onBlur: onBlur,
                disabled: __props.disabled
            }, null, 40, _hoisted_1));
        };
    }
});
